export const services = [
  {
    id: 'privatrengoring',
    title: {
      da: 'Privatrengøring',
      en: 'Private Cleaning'
    },
    description: {
      da: 'Vi hjælper med rengøring af huse, lejligheder og sommerhuse – fast aftale eller enkeltbesøg. Inkluderer støvsugning, gulvvask, aftørring og rengøring af køkken/bad.',
      en: 'We help with cleaning of houses, apartments, and holiday homes – fixed agreement or single visits. Includes vacuuming, floor washing, wiping, and cleaning of kitchen/bath.'
    },
    details: {
      da: [
        'Støvsugning og gulvvask',
        'Aftørring af overflader',
        'Rengøring af køkken og badeværelse',
        'Spar 26% med servicefradrag'
      ],
      en: [
        'Vacuuming and floor washing',
        'Wiping of surfaces',
        'Cleaning of kitchen and bathroom',
        'Save 26% with service deduction'
      ]
    },
    image: '/images/private-cleaning.png',
    link: '/privatrengoring'
  },
  {
    id: 'erhvervsrengoring',
    title: {
      da: 'Erhvervsrengøring',
      en: 'Business Cleaning'
    },
    description: {
      da: 'Et rent arbejdsmiljø giver trivsel og et professionelt indtryk. Vi tilbyder skræddersyede løsninger til kontorer og virksomheder.',
      en: 'A clean work environment provides well-being and a professional impression. We offer tailored solutions for offices and businesses.'
    },
    details: {
      da: [
        'Kontorrengøring',
        'Klinikrengøring',
        'Butiksrengøring',
        'Trappevask'
      ],
      en: [
        'Office cleaning',
        'Clinic cleaning',
        'Shop cleaning',
        'Staircase cleaning'
      ]
    },
    image: '/images/business-cleaning.png',
    link: '/erhvervsrengoring'
  },
  {
    id: 'flytterengoring',
    title: {
      da: 'Flytterengøring',
      en: 'Move-out Cleaning'
    },
    description: {
      da: 'Skal du flytte? Vi sørger for en grundig slutrengøring, så boligen er klar til aflevering. Vi tager os af alt det grove.',
      en: 'Moving? We ensure a thorough final cleaning so the home is ready for handover. We take care of all the heavy lifting.'
    },
    details: {
      da: [
        'Grundig rengøring af alle rum',
        'Afkalkning af badeværelse',
        'Rengøring af ovn og køleskab',
        'Vinduer efter aftale'
      ],
      en: [
        'Thorough cleaning of all rooms',
        'Descaling of bathroom',
        'Cleaning of oven and refrigerator',
        'Windows by agreement'
      ]
    },
    image: '/images/move-cleaning.png',
    link: '/tjenester'
  }
];

export const stats = [
  { 
    label: { da: 'Kommune dækket', en: 'Municipalities covered' }, 
    value: '3' 
  },
  { 
    label: { da: 'Faste kunder', en: 'Regular customers' }, 
    value: '50+' 
  },
  { 
    label: { da: 'Kundetilfredshed', en: 'Customer satisfaction' }, 
    value: '100%' 
  }
];

export const testimonials = [
  {
    name: 'Mette Hansen',
    role: { da: 'Boligejer, Billund', en: 'Homeowner, Billund' },
    text: {
      da: 'FTR Service har gjort vores hverdag meget lettere. Det er altid en fornøjelse at komme hjem til et rent hus.',
      en: 'FTR Service has made our everyday life much easier. It is always a pleasure to come home to a clean house.'
    }
  },
  {
    name: 'Lars Nielsen',
    role: { da: 'Direktør, Vejle', en: 'Director, Vejle' },
    text: {
      da: 'Vi har brugt FTR Service til vores kontorrengøring i over to år. De er pålidelige, grundige og altid professionelle.',
      en: 'We have used FTR Service for our office cleaning for over two years. They are reliable, thorough, and always professional.'
    }
  },
  {
    name: 'Sofie Andersen',
    role: { da: 'Flyttekunde, Varde', en: 'Moving customer, Varde' },
    text: {
      da: 'Flytterengøringen var helt fantastisk. Udlejeren havde intet at udsætte på det, og vi fik hele depositummet tilbage.',
      en: 'The move-out cleaning was absolutely fantastic. The landlord had nothing to complain about, and we got the full deposit back.'
    }
  }
];

export const contactInfo = {
  name: 'FTR Service ApS',
  owner: 'c/o Tamar Fechete',
  address: 'Montanavej 1 R1',
  zipCity: '7190 Billund',
  phone: '+45 91 84 76 66',
  email: 'info@ftrservice.dk',
  facebook: 'https://www.facebook.com/FTRServiceApS'
};
